import { AppModel } from "src/store/models/app";
import { entityModels } from "src/store/models/entity";
import { logicModels } from "src/store/models/logic";
import { PopMenuModel } from "src/store/models/popMenu";
import { RouterModel } from "src/store/models/router";
import { uiModels } from "src/store/models/ui";

export const rootModels = {
  _router: RouterModel,
  app: AppModel,
  sidebar: PopMenuModel,
  entity: entityModels,
  ui: uiModels,
  logic: logicModels,
};
